"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Material = void 0;
var Material = /** @class */ (function () {
    function Material(_a) {
        var _b = _a._id, _id = _b === void 0 ? '' : _b, _c = _a.DS_MATERIAL, DS_MATERIAL = _c === void 0 ? '' : _c, _d = _a.CD_PLANEJADOR, CD_PLANEJADOR = _d === void 0 ? '' : _d, _e = _a.CD_CALENDARIO, CD_CALENDARIO = _e === void 0 ? '' : _e, _f = _a.TIPO_SUP, TIPO_SUP = _f === void 0 ? '' : _f, _g = _a.STATUS_MAT, STATUS_MAT = _g === void 0 ? '' : _g, _h = _a.GRADE_MATERIAL, GRADE_MATERIAL = _h === void 0 ? new Array() : _h, _j = _a.CARACT_MATERIAL, CARACT_MATERIAL = _j === void 0 ? {} : _j, _k = _a.LISTA_TECNICA, LISTA_TECNICA = _k === void 0 ? {} : _k, _l = _a.SEAMLESS, SEAMLESS = _l === void 0 ? false : _l;
        this._id = _id;
        this.DS_MATERIAL = DS_MATERIAL;
        this.CD_PLANEJADOR = CD_PLANEJADOR;
        this.CD_CALENDARIO = CD_CALENDARIO;
        this.TIPO_SUP = TIPO_SUP;
        this.STATUS_MAT = STATUS_MAT;
        this.GRADE_MATERIAL = GRADE_MATERIAL;
        this.CARACT_MATERIAL = CARACT_MATERIAL;
        this.LISTA_TECNICA = LISTA_TECNICA;
        this.SEAMLESS = SEAMLESS;
    }
    return Material;
}());
exports.Material = Material;
//# sourceMappingURL=Material.js.map